import { inject } from '@angular/core';
import {
  callApiMethod,
  setError,
  withExport,
  withResourceState,
} from '@kinet-open-network/client/shared/data-access/state';
import { StockMoveItem } from '@kinet-open-network/client/stock-moves/data-access';
import { IStockItemBalance } from '@kinet-open-network/shared/data-access/model';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { StockItemsService } from '../services/stock-items.service';

interface StockItemsState {
  movements: StockMoveItem[];
  movementsLoading: boolean;
  qtys: IStockItemBalance[];
  qtysLoading: boolean;
}

export const StockItemsStore = signalStore(
  { protectedState: false }, withResourceState(StockItemsService),
  withExport(StockItemsService),
  withState<StockItemsState>({
    movements: [],
    movementsLoading: false,
    qtys: [],
    qtysLoading: false,
  }),
  withMethods((store, service = inject(StockItemsService)) => ({
    loadMovements: (stockItemId: string) => {
      patchState(store, { movementsLoading: true });
      return callApiMethod(() => service.movements(stockItemId), {
        next: (movements) => patchState(store, { movements }),
        error: (err) => patchState(store, setError(err)),
        finalize: () => patchState(store, { movementsLoading: false }),
      });
    },
    loadQtys: (stockItemId: string) => {
      patchState(store, { qtysLoading: true });
      return callApiMethod(() => service.balances(stockItemId), {
        next: (data) => patchState(store, { qtys: data.data }),
        error: (err) => patchState(store, setError(err)),
        finalize: () => patchState(store, { qtysLoading: false }),
      });
    },
  })),
);
